import { render, staticRenderFns } from "./CPTooltipAdvanced.vue?vue&type=template&id=42fb8773&scoped=true&"
import script from "./CPTooltipAdvanced.vue?vue&type=script&lang=ts&"
export * from "./CPTooltipAdvanced.vue?vue&type=script&lang=ts&"
import style0 from "./CPTooltipAdvanced.vue?vue&type=style&index=0&id=42fb8773&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb8773",
  null
  
)

export default component.exports